'use client';

import { event_field_error } from '@/utils/gtm';
import { getIn, useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';

/**
 * DAAM: errors shown in the UI fire `errors` too. Reports the error a field
 * shows once per submit attempt, when the submit settles, so fixing the field
 * does not fire on every keystroke. Covers validation errors and API errors a
 * handler puts on the field with `setFieldError`.
 */
export default function useReportFieldError(name) {
  const formik = useFormikContext();
  const isSubmitting = formik?.isSubmitting;
  const error = getIn(formik?.errors, name);
  const wasSubmitting = useRef(false);

  useEffect(() => {
    if (isSubmitting) {
      wasSubmitting.current = true;
      return;
    }
    if (!wasSubmitting.current) return;
    wasSubmitting.current = false;

    if (typeof error === 'string' && error.trim())
      event_field_error({ message: error });
  }, [isSubmitting, error]);
}
